// Utility function to change favicon dynamically
export const changeFavicon = (institution) => {
  const faviconMap = {
    'UND': 'favicon-und.png',
    'UNCR': 'favicon-uncr.png',
    'CIERHA': 'favicon-uncr.png',
    'DPHU': 'favicon-dphu.png',
    'GOMA': 'favicon-goma.png',
    'KISANGANI': 'favicon-kisangani.png',
    'ISTAM': 'favicon-istam.png',
    'UNIKAL': 'favicon-unikal.png',
    'MUKEDI': 'favicon-mukedi.png',
    'UNIM': 'favicon-unim.png',
    'default': 'edaplogo.png' // fallback to original
  };

  const faviconPath = faviconMap[institution] || faviconMap.default;
  
  // Remove existing favicon links
  const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
  existingFavicons.forEach(favicon => favicon.remove());
  
  // Create new favicon link
  const newFavicon = document.createElement('link');
  newFavicon.rel = 'icon';
  newFavicon.type = 'image/png';
  newFavicon.href = `${process.env.PUBLIC_URL || ''}/${faviconPath}`;
  
  // Add to head
  document.head.appendChild(newFavicon);
};

// Extract institution name from pathname
export const getInstitutionFromPath = (pathname) => {
  const institutionMap = {
    '/adminUND': 'UND',
    '/adminUNCR': 'UNCR',
    '/adminCIERHA': 'CIERHA',
    '/adminDPHU': 'DPHU',
    '/adminGOMA': 'GOMA',
    '/adminKISA': 'KISANGANI',
    '/adminISTAM': 'ISTAM',
    '/adminUNIKAL': 'UNIKAL',
    '/adminMUKEDI': 'MUKEDI',
    '/adminUNIM': 'UNIM'
  };
  
  return institutionMap[pathname] || 'default';
};
